module.exports = __webpack_public_path__ + "static/boredom_spanish-59a4cbde5ac268514feef124ba1e98bc.png";